export enum Cookie {
    LoginSession = 'login_session',
    Vid = 'VID',
    AdminUserId = 'AUID',
    SsoRetryCount = 'sso-retry-count',
}
